import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils';
import {
  Box,
  BoxProps,
  GridItem,
  GridProps,
  Responsive,
} from 'app/shared/components/atoms';
import { BasePageGrid } from 'app/fan/components/templates/BasePageGrid';

export const EventPageGrid = ({
  children,
  ...props
}: React.PropsWithChildren<GridProps>) => {
  const { isDesktop } = useIsBreakpointSize();

  return (
    <BasePageGrid
      rowGap={isDesktop ? 20 : 10}
      pt={[0, 10, 10, 10]}
      pb={[16, 20, 20, 20]}
      {...props}
    >
      {children}
    </BasePageGrid>
  );
};

export const EventPageFirstColumn = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <GridItem
      mobile={4}
      tablet={8}
      mobileStart={1}
      tabletStart={1}
      smallDesktopStart={1}
      largeDesktopStart={1}
    >
      {children}
    </GridItem>
  );
};

export const EventPageDesktopSecondColumn = ({
  children,
  ...props
}: BoxProps) => {
  const { borderRadius, boxShadow, ruler, colors } = useCurrentTheme();

  return (
    <Responsive showUp="smallDesktop">
      <GridItem
        mobile={4}
        mobileStart={1}
        tablet={8}
        smallDesktop={4}
        smallDesktopStart={9}
        largeDesktopStart={9}
      >
        <Box
          position="sticky"
          top={`${ruler[10]}px`}
          justifyContent="center"
          alignItems="center"
          boxShadow={boxShadow.singleShadow}
          borderRadius={borderRadius.card}
          backgroundColor={colors.primary.white.base}
          {...props}
        >
          {children}
        </Box>
      </GridItem>
    </Responsive>
  );
};
